import { AutogenLayoutJobClassLookup } from "./autogen/AutogenLayoutJobClassLookup";

export class JobClassLookup extends AutogenLayoutJobClassLookup {
}
